import { render } from "./AnketaView.vue?vue&type=template&id=a13dd6a2&scoped=true"
import script from "./AnketaView.vue?vue&type=script&lang=js"
export * from "./AnketaView.vue?vue&type=script&lang=js"

import "./AnketaView.vue?vue&type=style&index=0&id=a13dd6a2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13dd6a2"]])

export default __exports__